export const UPDATE_FUND_FILTER = 'UPDATE_FUND_FILTER';
export const SET_DIGITAL_FUND = 'SET_DIGITAL_FUND';
export const SET_CAPITAL_FUND = 'SET_CAPITAL_FUND';
export const ALLOCATE_FUND_SPLIT = 'ALLOCATE_FUND_SPLIT';
export const SET_LUMPSUM = 'SET_LUMPSUM';
export const SET_MONTHLY_CONTRIBUTION = 'SET_MONTHLY_CONTRIBUTION';
export const UPDATE_DURATION = 'UPDATE_DURATION';
export const SIGN_UP = 'SIGN_UP';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';
export const TOGGLE_WALKTHROUGH_COMPLETE = 'TOGGLE_WALKTHROUGH_COMPLETE';
export const UPDATE_LOCAL_PLANHOLDER = 'UPDATE_LOCAL_PLANHOLDER';
export const UPDATE_LOCAL_BENEFICIARY = 'UPDATE_LOCAL_BENEFICIARY';